export default __webpack_public_path__ + "static/media/zukunf_lauft_background_xl2.adeddcbe.jpg";